import { createApiCall } from 'lib/base';

const POST_INVESTCORE_ORDER_UPDATE_API_ID =
  'POST_INVESTCORE_ORDER_UPDATE_API_ID';

interface UpdateOrderParams {
  id: string;
  fund_order_status: string;
  fund_payment_status?: string;
  fund_amount?: number;
  fund_net_amount?: number;
  fund_quantity?: number;
  fund_matched_price?: number;
  fund_fee_amount?: number;
  fund_tax_amount?: number;
}

const apiCall = createApiCall<UpdateOrderParams>(
  POST_INVESTCORE_ORDER_UPDATE_API_ID,
  ({ id, ...payload }) => ({
    endpoint: `/api/admin/orders/${id}`,
    method: 'PATCH',
    body: JSON.stringify(payload),
  })
);

export default apiCall;
